import { render, staticRenderFns } from "./opcs.vue?vue&type=template&id=2e7973d2&scoped=true"
import script from "./opcs.vue?vue&type=script&lang=js"
export * from "./opcs.vue?vue&type=script&lang=js"
import style0 from "./opcs.vue?vue&type=style&index=0&id=2e7973d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7973d2",
  null
  
)

export default component.exports